import { render, staticRenderFns } from "./DetailRecommendInfo.vue?vue&type=template&id=d628402c&scoped=true&"
import script from "./DetailRecommendInfo.vue?vue&type=script&lang=js&"
export * from "./DetailRecommendInfo.vue?vue&type=script&lang=js&"
import style0 from "./DetailRecommendInfo.vue?vue&type=style&index=0&id=d628402c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d628402c",
  null
  
)

export default component.exports